import { ProductState } from 'protocol/api/billing_new/dto_product_new_pb';
import { Service } from 'protocol/api/billing_new/dto_services_new_pb';

export const getServicesFromSubscriptionList = (products: ProductState[]) =>
  products.reduce(
    (services, product) => services.concat(product?.Services ?? []),
    [] as Service[],
  );
